import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onMounted, reactive, watch} from "vue";
import {getCSSVariableValue} from "@/assets/ts/_utils";

// 表格载入延迟

export default /*#__PURE__*/_defineComponent({
  props: {
  title: { type: String, required: true },  // 标题
  dimension: { type: String, required: true },  // 指定的数据维度
  field: { type: String, required: true },  // 指定的指标字段
  data: {type: Array, required: true},  // 图形数据
},
  setup(__props) {

const props = __props

const loading = ref<boolean>(false);
const chart = ref<HTMLElement | null>(null);

const labelColor = getCSSVariableValue("--bs-" + "gray-800");
const strokeColor = getCSSVariableValue("--bs-" + "gray-300");
const baseColor = getCSSVariableValue("--bs-" + "primary");
const lightColor = getCSSVariableValue("--bs-light-" + "primary");
const series = ref<Array<any>>([]);
const options = reactive({
  title: {
    text: props.title,
    align: 'center',
    style: {
      fontSize:  '14px',
      fontFamily: "inherit",
    }
  },
  chart: {
    type: 'pie',
  },
  labels: [] as any[],
  legend: {
    show: false,
  },
  dataLabels: {
    formatter(val, opts) {
      const name = opts.w.globals.labels[opts.seriesIndex]
      return [name, val.toFixed(1) + '%']
    }
  },
  colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#66DA26', '#7E36AF']
});

onMounted(() => {
});

watch(props, (val) => {
  if (val.data.length > 0) {
    loadData();
  }
});

// 数据载入
const loadData = () => {
  loading.value = true;
  // 先copy一份props.data再排序，否则会改变props.data，陷入死循环；按照指定的指标先排序
  let data = JSON.parse(JSON.stringify(props.data)).sort((a, b) => a[props.field] - b[props.field]).reverse();
  // 找出指定维度的前5个值
  options.labels = [...data.map(item => item[props.dimension]).slice(0, 5), '其他'];
  (chart as any).value.updateOptions(options);
  changeSeries();
  loading.value = false;
}

// 改变图表数据
const changeSeries = () => {
  // 先copy一份props.data再排序，否则会改变props.data，陷入死循环
  let data = JSON.parse(JSON.stringify(props.data)).map((item: any) => Number(item[props.field])).sort((a, b) => a - b).reverse();
  series.value = [0, 0, 0, 0, 0, 0];
  let i = 0;
  for (let d of data) {
    if (i < 5) {
      series.value[i] = Number(d);
    } else {
      if (series.value.length < 6) series.value.push(0);
      series.value[5] += Number(d);
    }
    i++;
  }
  series.value[5] = series.value[5] * 100 / 100;  // 解决浮点计算精度问题
  (chart as any).value.updateSeries(series.value);
}

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock(_component_apexchart, {
    ref_key: "chart",
    ref: chart,
    type: "pie",
    height: "200",
    options: _unref(options),
    series: series.value,
    class: "mixed-widget-7-chart card-rounded-bottom"
  }, null, 8, ["options", "series"]))
}
}

})